import React, { useEffect, useState } from "react";

export default function useMobileViewEnabled() {

    const isMobileViewEnabled = () => {
        if(window.innerWidth > 1200) {
            return false;
        } else if (window.innerWidth < 1200) {
            return true;
        }
    }

    const [ isMobileView, setIsMobileView ] = useState(isMobileViewEnabled);

    useEffect(()=>{
        const handleSize = () => setIsMobileView(isMobileViewEnabled);

        window.addEventListener('resize', handleSize);
        return ()=>{
            window.addEventListener('resize',handleSize); 
        }
    },[])

    return { isMobileView };
}